import type { GetTimeSettingsBreakConfigurationsQuery } from 'generated/resources/graphql'
import { GetTimeSettingsBreakConfigurationsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type TimeSettingsBreakConfiguration =
  GetTimeSettingsBreakConfigurationsQuery['timeSettings']['breakConfigurationsConnection']['nodes'][number]

type AttendanceBreakConfiguration = NonNullable<
  TimeSettingsBreakConfiguration['attendanceBreakConfiguration']
>[number]

type TimeSettingsBreakConfig = Omit<
  TimeSettingsBreakConfiguration,
  'attendanceBreakConfigurationConnection' | 'attendanceBreakConfiguration'
>

type AttendanceBreakConfig = Pick<AttendanceBreakConfiguration, 'id' | 'enabled'>
type AttendanceBreak = { attendanceBreakConfiguration: AttendanceBreakConfig[] }

export type TimeSettingsBreakConfigs = TimeSettingsBreakConfig & AttendanceBreak

export const useFetchTimeSettingsBreakConfigurations = (attendanceEmployeesSettingId: number) => {
  const { loading, data, refetch } = useQuery(GetTimeSettingsBreakConfigurationsDocument, {
    variables: { attendanceEmployeesSettingId },
    fetchPolicy: 'network-only',
  })

  const timeSettingsBreakConfigurations =
    data?.timeSettings.breakConfigurationsConnection.nodes || []

  const policies = data?.timeSettings?._policies

  return {
    loading,
    timeSettingsBreakConfigurations,
    refetch,
    manageBreakConfigurations: !!policies?.manageBreakConfigurations.can,
  }
}
